/**
 * Klaviyo newsletter embed configuration.
 *
 * KLAVIYO_NEWSLETTER_FORM_ID is the default embed form ("Newsletter sign-up",
 * TQLZN5 -> list "Newsletter" Ut4E4N), used when a Sanity document does not
 * override it with its own klaviyoFormId. Replaces the HubSpot newsletter embed.
 * The Klaviyo onsite script (klaviyo.js) is loaded via Google Tag Manager, not
 * from the app.
 */

export const KLAVIYO_NEWSLETTER_FORM_ID = 'TQLZN5'
